import { Box, Typography } from '@mui/material';
import { useCallback, useState } from 'react';
import { BulkTearsheetGeneration } from './BulkTearsheetGeneration';
import { TearsheetGenerationGridLoader } from './TearsheetGenerationGridLoader';

export function TearsheetGeneration() {
  const [refreshTrigger, setRefreshTrigger] = useState(0);

  const handleRefresh = useCallback(() => {
    setRefreshTrigger((prev) => prev + 1);
  }, []);

  return (
    <Box
      sx={{
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        padding: '8px 12px 12px',
        width: '100%',
        overflow: 'hidden',
      }}
    >
      <Typography variant='h4' component='h1' gutterBottom>
        Tearsheet Generation
      </Typography>
      <BulkTearsheetGeneration onRefresh={handleRefresh} />
      <Box flex={1} overflow='hidden' minHeight={0}>
        <TearsheetGenerationGridLoader refreshTrigger={refreshTrigger} />
      </Box>
    </Box>
  );
}
